/**
 * @author Vibhor <vibhor.sharma@314ecorp.com>
 * @description Enrollment details button
 */
import { Tooltip, Tag, Flex, Typography, Card } from 'antd';

import { ANT_TAG_COLORS } from '@veritable/common/constants/antd';
import { ELIGIBILITY_PAYER_ENROLLMENT_TAG_STATUS } from 'app-constants/eligibility';

export interface IProps {
	payer: Payers.ISelectedPayer;
}

const EnrollmentDetails: React.FC<IProps> = ({ payer }) => {
	const total = payer?.providerEnrollmentMeta?.total;
	const done = payer?.providerEnrollmentMeta?.done;
	if (payer.enrollmentRequired && total && total > 0) {
		const { requested, notEnrolled, failed } = payer?.providerEnrollmentMeta || {};

		return (
			<Tooltip
				arrow={false}
				classNames={{ root: 'enrollment-tooltip' }}
				title={
					<Card
						variant='borderless'
						title={
							<Typography.Title level={5} className='m-0'>
								Enrollment Summary
							</Typography.Title>
						}
					>
						<Flex vertical gap={12}>
							<Flex justify='space-between'>
								<Typography.Text>Total</Typography.Text>
								<Typography.Text>{total}</Typography.Text>
							</Flex>

							<Flex justify='space-between'>
								<Typography.Text style={{ color: ELIGIBILITY_PAYER_ENROLLMENT_TAG_STATUS.completed.color }}>
									{ELIGIBILITY_PAYER_ENROLLMENT_TAG_STATUS.completed.label}
								</Typography.Text>
								<Typography.Text>{done}</Typography.Text>
							</Flex>

							<Flex justify='space-between'>
								<Typography.Text style={{ color: ELIGIBILITY_PAYER_ENROLLMENT_TAG_STATUS.requested.color }}>
									{ELIGIBILITY_PAYER_ENROLLMENT_TAG_STATUS.requested.label}
								</Typography.Text>
								<Typography.Text>{requested}</Typography.Text>
							</Flex>

							<Flex justify='space-between'>
								<Typography.Text style={{ color: ELIGIBILITY_PAYER_ENROLLMENT_TAG_STATUS.notEnrolled.color }}>
									{ELIGIBILITY_PAYER_ENROLLMENT_TAG_STATUS.notEnrolled.label}
								</Typography.Text>
								<Typography.Text>{notEnrolled}</Typography.Text>
							</Flex>

							<Flex justify='space-between'>
								<Typography.Text style={{ color: ELIGIBILITY_PAYER_ENROLLMENT_TAG_STATUS.failed.color }}>
									{ELIGIBILITY_PAYER_ENROLLMENT_TAG_STATUS.failed.label}
								</Typography.Text>
								<Typography.Text>{failed}</Typography.Text>
							</Flex>
						</Flex>
					</Card>
				}
			>
				<Tag>Yes</Tag>
				<Tag color={ANT_TAG_COLORS.blue}>{`${done}/${total}`}</Tag>
			</Tooltip>
		);
	}
	// providerEnrollmentMeta is absent for type2, fall back to enrollmentRequired alone to determine Yes/No
	if (payer?.enrollmentRequired) {
		return <Tag>Yes</Tag>;
	}
	return <Tag>No</Tag>;
};

export default EnrollmentDetails;
